const values = [
  {
    icon: 'ri-heart-2-line',
    title: '공감과 존중',
    desc: '장애인과 활동지원사 모두의 이야기에 귀 기울이며 서로를 존중하는 문화를 만듭니다.',
  },
  {
    icon: 'ri-graduation-cap-line',
    title: '전문성 강화',
    desc: '체계적인 교육 프로그램으로 활동지원사의 역량을 높이고 서비스 품질을 향상시킵니다.',
  },
  {
    icon: 'ri-community-line',
    title: '따뜻한 연대',
    desc: '고립되지 않도록 서로 연결하고, 함께 성장하는 복지 커뮤니티를 지향합니다.',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '나눔의 실천',
    desc: '후원과 참여를 통해 더 많은 분들이 복지 혜택을 누릴 수 있도록 연결합니다.',
  },
];

export default function MissionSection() {
  return (
    <section id="mission" className="py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid lg:grid-cols-2 gap-20 items-center mb-24">
          <div>
            <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 rounded-full px-4 py-1.5 text-sm font-semibold mb-6">
              <i className="ri-flag-2-line text-amber-600"></i>
              OUR MISSION
            </div>
            <h2 className="text-5xl font-bold text-stone-800 leading-tight mb-6">
              활동지원사와 장애인이<br />
              <span className="text-amber-600">함께 성장하는</span><br />
              복지 생태계를 만듭니다
            </h2>
            <p className="text-stone-600 text-lg leading-relaxed mb-8">
              대한효복지센터는 2009년 설립 이후 장애인의 자립 생활과 활동지원사의 전문성 향상을 위해 헌신해 왔습니다.
              우리는 단순한 서비스 제공을 넘어, 장애인과 활동지원사가 서로를 이해하고 함께 성장하는
              따뜻한 공동체를 만들어 나가고 있습니다.
            </p>
            <div className="flex gap-3">
              <div className="flex-1 bg-white rounded-2xl p-6 border border-stone-200">
                <p className="text-4xl font-bold text-amber-600 mb-1">15년</p>
                <p className="text-stone-500 text-sm">복지 서비스 경력</p>
              </div>
              <div className="flex-1 bg-white rounded-2xl p-6 border border-stone-200">
                <p className="text-4xl font-bold text-amber-600 mb-1">98%</p>
                <p className="text-stone-500 text-sm">이용자 만족도</p>
              </div>
              <div className="flex-1 bg-white rounded-2xl p-6 border border-stone-200">
                <p className="text-4xl font-bold text-amber-600 mb-1">50+</p>
                <p className="text-stone-500 text-sm">교육 프로그램</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden aspect-[4/3]">
              <img
                src="https://public.readdy.ai/ai/img_res/631a4e2baea8e5b9ed64ab5518bf69d8.jpg"
                alt="대한효복지센터 사명"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -top-4 -right-4 bg-amber-600 text-white rounded-2xl p-4">
              <p className="text-2xl font-bold">1,200+</p>
              <p className="text-amber-200 text-xs">활동지원사 가족</p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v) => (
            <div key={v.title} className="bg-white rounded-2xl p-7 border border-stone-200 hover:border-amber-300 transition-colors group">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-50 rounded-xl mb-4 group-hover:bg-amber-100 transition-colors">
                <i className={`${v.icon} text-amber-600 text-xl`}></i>
              </div>
              <h3 className="font-bold text-stone-800 mb-3">{v.title}</h3>
              <p className="text-stone-500 text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
